'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { usePageLoading } from '@/hooks/usePageLoading';

export const usePageLoadingReset = () => {
	const pathname = usePathname();
	const { resetPageLoading } = usePageLoading();

	useEffect(() => {
		resetPageLoading();
	}, [pathname, resetPageLoading]);
};
